import { useEffect, useState } from "react";
import { api } from "../lib/api";

function initialsOf(name = "") {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  return (parts[0][0] + (parts[1]?.[0] || "")).toUpperCase();
}

function bgColor(name = "?") {
  const palette = ["#2842a0", "#3a5cc7", "#4F66B5", "#1f2a44", "#5b6db5", "#6477c7", "#7286ce"];
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  return palette[h % palette.length];
}

/**
 * Universal avatar with initials fallback.
 * Pass either `src` (absolute) or `picture` (relative /api/files path).
 */
export default function Avatar({ name = "", src, picture, size = 40, className = "", ring = false }) {
  const base = (api.defaults.baseURL || "").replace(/\/api$/, "");
  const url = src || (picture && (picture.startsWith("http") ? picture : `${base}${picture}`));
  const [errored, setErrored] = useState(false);
  useEffect(() => { setErrored(false); }, [url]);
  const px = `${size}px`;
  const ringCls = ring ? "ring-2 ring-blanc shadow" : "";
  if (url && !errored) {
    return (
      <img
        src={url}
        alt={name}
        onError={() => setErrored(true)}
        className={`rounded-full object-cover ${ringCls} ${className}`}
        style={{ width: px, height: px }}
      />
    );
  }
  return (
    <div
      className={`rounded-full grid place-items-center text-blanc font-display font-bold ${ringCls} ${className}`}
      style={{
        width: px, height: px,
        backgroundColor: bgColor(name || "?"),
        fontSize: Math.max(11, Math.round(size * 0.38)),
      }}
      aria-label={name}
    >
      {initialsOf(name)}
    </div>
  );
}
